import {
  Checker,
  Id,
  RequestConferenceSituation,
  RequestConferenceStatus,
  RequestTicketStatusSync,
  RequestUserData
} from 'src/types'

import {
  ResponseDataRequests,
  ResponseDataRequestsItem
} from '../requests/types'

export enum ConferencesActionTypes {
  GET_CONFERENCES = '@conferences/GET_CONFERENCES',
  GET_CONFERENCES_FAILURE = '@conferences/GET_CONFERENCES_FAILURE',
  GET_CONFERENCES_SUCCESS = '@conferences/GET_CONFERENCES_SUCCESS',
  SET_CONFERENCE_STATUS = '@conferences/SET_CONFERENCE_STATUS',
  SET_CONFERENCE_STATUS_FAILURE = '@conferences/SET_CONFERENCE_STATUS_FAILURE',
  SET_CONFERENCE_STATUS_SUCCESS = '@conferences/SET_CONFERENCE_STATUS_SUCCESS'
}

interface RequestConference {
  request_conference_id: Id
  request_user_data: RequestUserData
  situation: RequestConferenceSituation
  status: RequestConferenceStatus
}

interface ResponseDataConferencesItem
  extends Omit<ResponseDataRequestsItem, 'status'> {
  checkers: Checker[]
  request_conferences: RequestConference[]
  status: RequestConferenceStatus
  sync_status: RequestTicketStatusSync
}

export interface ResponseDataConferences
  extends Omit<ResponseDataRequests, 'requests'> {
  requests: ResponseDataConferencesItem[]
}

export interface ConferencesState {
  readonly error: string
  readonly filterStatus: string[]
  readonly list: ResponseDataConferencesItem[]
  readonly loading: boolean
  readonly setStatusError: string
  readonly setStatusLoading: boolean
  readonly setStatusSuccess: string
  readonly total_results: number
}
